/* eslint camelcase: off */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider } from 'antd';
import ru_RU from 'antd/lib/locale/ru_RU';
import { ConfigProviderWrap } from '@ant-design/pro-provider';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import moment from 'moment';
import 'dayjs/locale/ru';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import App from './App';
import { rootReducer } from './Redux/rootReducer';
import './index.css';

const store = createStore(rootReducer, compose(applyMiddleware(thunk)));
moment.locale('ru');
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ConfigProvider
        locale={ru_RU}
        moment={moment}
        theme={{
            token: {
                colorPrimary: 'var(--primary-gray)',
                fontFamily: 'Ubuntu',
            },
            components: {
                Button: {
                    primaryColor: 'var(--primary-gray)',
                    contentFontSize: '14px',
                    colorPrimary: 'var(--primary-yellow)',
                    colorPrimaryActive: 'var(--white)',
                    colorPrimaryHover: 'var(--primary-yellow-hover)',
                    borderRadius: '10px',
                    primaryShadow: '0 0 0 var(--white)',
                },
            },
        }}
    >
        <ConfigProviderWrap>
            <Provider store={store}>
                <App />
            </Provider>
        </ConfigProviderWrap>
    </ConfigProvider>
);
